import { FormLayout, TextInput } from 'components/common'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { getNestedErrorMessage } from 'utils/helpers/getNestedErrorMessage'
import { configRootFields, configurationsFields, ERP_FIELDS } from './utils'

interface SapConfigurationSectionProps {
  register: UseFormRegister<any>
  errors: FieldErrors<any>
}

const SapConfigurationSection = ({
  register,
  errors,
}: SapConfigurationSectionProps) => {
  const { SAP_AUTH, SAP_ERP_ORDER, SAP_ERP_RMA, SAP_ERP_RECONCILIATION } =
    configRootFields
  const { SAP_INVENTORY_UPDATE_WINDOW_START, SAP_INVENTORY_UPDATE_WINDOW_END } =
    configurationsFields

  return (
    <>
      <h3 className="title mt-3">SAP Configuration</h3>

      <FormLayout>
        <div className="flex flex-col gap-6">
          {/* SAP Auth */}
          <div>
            <p className="mb-3 text-sm font-semibold text-gray-700">
              Auth Configuration
            </p>
            <div className="grid gap-x-10 gap-y-3">
              <TextInput
                required
                register={register}
                name={SAP_AUTH + '.' + ERP_FIELDS.URL}
                label="End Point"
                error={getNestedErrorMessage(errors, {
                  key: ERP_FIELDS.URL,
                  parentKey: SAP_AUTH,
                })}
              />
              <div className="grid gap-x-10 gap-y-3 mid-md:grid-cols-2">
                <TextInput
                  required
                  register={register}
                  name={SAP_AUTH + '.' + ERP_FIELDS.USERNAME}
                  label="Username"
                  error={getNestedErrorMessage(errors, {
                    key: ERP_FIELDS.USERNAME,
                    parentKey: SAP_AUTH,
                  })}
                />
                <TextInput
                  required
                  type="password"
                  register={register}
                  name={SAP_AUTH + '.' + ERP_FIELDS.PASSWORD}
                  label="Password"
                  error={getNestedErrorMessage(errors, {
                    key: ERP_FIELDS.PASSWORD,
                    parentKey: SAP_AUTH,
                  })}
                />
              </div>
            </div>
          </div>

          <div className="border-t" />

          {/* SAP Order ERP */}
          <div>
            <p className="mb-3 text-sm font-semibold text-gray-700">
              Order ERP
            </p>
            <TextInput
              required
              register={register}
              name={SAP_ERP_ORDER + '.' + ERP_FIELDS.URL}
              label="End Point"
              error={getNestedErrorMessage(errors, {
                key: ERP_FIELDS.URL,
                parentKey: SAP_ERP_ORDER,
              })}
            />
          </div>

          <div className="border-t" />

          {/* SAP RMA ERP */}
          <div>
            <p className="mb-3 text-sm font-semibold text-gray-700">RMA ERP</p>
            <TextInput
              required
              register={register}
              name={SAP_ERP_RMA + '.' + ERP_FIELDS.URL}
              label="End Point"
              error={getNestedErrorMessage(errors, {
                key: ERP_FIELDS.URL,
                parentKey: SAP_ERP_RMA,
              })}
            />
          </div>

          <div className="border-t" />

          {/* SAP Reconciliation ERP */}
          <div>
            <p className="mb-3 text-sm font-semibold text-gray-700">
              Reconciliation ERP
            </p>
            <TextInput
              required
              register={register}
              name={SAP_ERP_RECONCILIATION + '.' + ERP_FIELDS.URL}
              label="End Point"
              error={getNestedErrorMessage(errors, {
                key: ERP_FIELDS.URL,
                parentKey: SAP_ERP_RECONCILIATION,
              })}
            />
          </div>

          <div className="border-t" />

          {/* SAP Inventory Update Window */}
          <div>
            <p className="mb-3 text-sm font-semibold text-gray-700">
              Inventory Update Window
            </p>
            <div className="grid gap-x-10 gap-y-3 mid-md:grid-cols-2">
              <TextInput
                type="time"
                register={register}
                name={SAP_INVENTORY_UPDATE_WINDOW_START.key}
                label={SAP_INVENTORY_UPDATE_WINDOW_START.label}
                hintText="24-hour, Gulf Standard Time. Leave both blank to turn off."
                error={
                  errors[SAP_INVENTORY_UPDATE_WINDOW_START.key]
                    ?.message as string
                }
              />
              <TextInput
                type="time"
                register={register}
                name={SAP_INVENTORY_UPDATE_WINDOW_END.key}
                label={SAP_INVENTORY_UPDATE_WINDOW_END.label}
                hintText="Must be after the start time (same day)."
                error={
                  errors[SAP_INVENTORY_UPDATE_WINDOW_END.key]?.message as string
                }
              />
            </div>
            <p className="mt-2 text-xs text-gray-500">
              During this window, SAP inventory updates the ERP QTY of blocked
              barcodes that have Allow Erp Window Update on, but only when SAP
              sends a quantity greater than 0.
            </p>
          </div>
        </div>
      </FormLayout>
    </>
  )
}

export default SapConfigurationSection
